import { FilterOption } from '../../models/gen/graphql';
import { GetOverrideClientsDocument } from '../../api/queries';
import SelectFromQuery from '../SelectFromQuery';

// SKYP-10064: the client for a manifest-override location can be a client (hotel) OR the
// import's airline. GetOverrideImportOptions returns a provider id for either case, so the
// dropdown must include both provider sets — otherwise the airline default (and any client
// not in the clients-only filter) renders blank. Merge and de-duplicate by id.
const SelectOverrideClient = (props) => (
  <SelectFromQuery
    placeholder="Select Client"
    query={GetOverrideClientsDocument}
    selector={(data) => {
      const clients = data?.getFilters?.filters?.clients || [];
      const airlines = data?.getFilters?.filters?.airline || [];
      const seen = new Set<string>();
      return [...clients, ...airlines].reduce((acc: { label: string; value: string }[], { id, displayName }: FilterOption) => {
        if (!id || seen.has(id)) return acc;
        seen.add(id);
        acc.push({ label: displayName, value: id });
        return acc;
      }, []);
    }}
    {...props}
    options={{ cache: 'OverrideClients', ...(props?.options || {}) }}
  />
);

export default SelectOverrideClient;
